import React, { useEffect, useState, useRef } from "react";
import { Pagination } from "../components/common";
import DataTable from "react-data-table-component";
import { topLoaderProgress } from "../configs";
import { CallLogResponseModel } from "../models/api/Call";
import { CallStatusType } from "../configs";
import { useFunctionalityCallSummary } from "../pages/hooks";
import { NoDataComponent } from "./admin/noDataComponent";
import { usePersistedPagingLocal } from "../pages/hooks/usePersistedPagingLocal";

type Props = {
  className?: string;
  pagingKey?: string,
  pageHeader: string;
  tableHeaders: any[];
  tableData: any[];
  setCreateModalShow?: (value: boolean) => void;
  pageSize?: number;
  pageIndex?: number;
  count?: number;
  onChangePageIndex?: any;
  onChangePageSize?: any;
  isPageEnabled?: boolean | true;
  loaderProgress: number;
  searchText?: string;
  filterDataChange?: number;
  setCallSummaryData?: any;
  setLoaderProgress?: any;
  setShow?: any;
  enableRowClick?: boolean;
};

export function CallLogTableDataWeb(props: Props): JSX.Element {
  const { pagingKey, tableData, tableHeaders, pageSize, pageIndex, count, onChangePageIndex, onChangePageSize, isPageEnabled, pageHeader, loaderProgress, searchText, filterDataChange, setCallSummaryData, setLoaderProgress, setShow, enableRowClick } = props;
  const [noDataComponentText, setNoDataComponentText] = useState("Loading...");

  useEffect(() => {
    if (loaderProgress == topLoaderProgress.complete) {
      setNoDataComponentText(tableData?.length == 0
        ? "There are no records to display"
        : "Loading..."
      );
    }
  }, [loaderProgress, tableData]);

  const initialDefaultsRef = useRef({
    pageNo: pageIndex && pageIndex > 0 ? pageIndex : 1,
    pageSize: pageSize && pageSize > 0 ? pageSize : 10,
  });

  const storageKey = pagingKey ? `paging:${pagingKey}` : "";
  const { paging, setPaging } = usePersistedPagingLocal(
    storageKey,
    initialDefaultsRef.current
  );
  const { pageNo, pageSize: pageSizeLocal } = paging;

  useEffect(() => {
    onChangePageSize?.(pageSizeLocal);
    onChangePageIndex?.(pageNo);
  }, [pageNo, pageSizeLocal, onChangePageIndex, onChangePageSize]);

  const resetSignalRef = useRef({
    searchText,
    filterDataChange,
  });

  useEffect(() => {
    const prev = resetSignalRef.current;
    const searchChanged = (searchText ?? "") !== (prev.searchText ?? "");
    const filterChanged = filterDataChange !== prev.filterDataChange;

    if ((searchChanged || filterChanged) && pageNo !== 1) {
      setPaging((state) => ({ ...state, pageNo: 1 }));
    }

    resetSignalRef.current = { searchText, filterDataChange };
  }, [searchText, filterDataChange, pageNo, setPaging]);


  const { LoadById } = useFunctionalityCallSummary();
  const isRowClickEnabled =
    enableRowClick ?? Boolean(setShow || setCallSummaryData);
  const handleCallLogDetailsView = (callLog: any) => {
    if (!isRowClickEnabled) return;
    if (setLoaderProgress)
      setLoaderProgress(topLoaderProgress.start);
    LoadById(callLog.id).then((data) => {
      if (setLoaderProgress)
        setLoaderProgress(topLoaderProgress.complete);
      if (setCallSummaryData && data) setCallSummaryData(data);
      setShow(true);
    });
  };
  const conditionalRowStyles = [
    {
      when: (row: CallLogResponseModel) => row.callStatusType == CallStatusType.Missed
        || row.callStatusType == CallStatusType.Rejected,
      style: {
        color: 'red',
      },
    },
  ]

  return (
    <>
      <div className={`col-12 ${props.className ?? ''}`}>
        <div className="component-card">
          <div className="component-card-header d-flex align-items-center justify-content-between border-top border-right border-left ">
            <div>
              <span>{pageHeader}</span>
            </div>
          </div>
          <div className="component-card-body border p-0 overflow-hidden">
            <div className="call-log-table-container-lg  d-md-block d-lg-block d-xl-block">
              <div className="table-responsive">
                <DataTable
                  noDataComponent={
                    <NoDataComponent title={noDataComponentText} />
                  }
                  columns={tableHeaders}
                  conditionalRowStyles={conditionalRowStyles}
                  data={tableData}
                  highlightOnHover={true}
                  pointerOnHover={isRowClickEnabled}
                  onRowClicked={isRowClickEnabled ? handleCallLogDetailsView : undefined} />
                {isPageEnabled ? (
                  <Pagination
                    pageSize={pageSizeLocal}
                    pageIndex={pageNo}
                    count={count}
                    onChangePageIndex={(next: number) => {
                      setPaging(p => ({ ...p, pageNo: next }));
                      onChangePageIndex?.(next);
                    }}
                    onChangePageSize={(next: number) => {
                      const Snew = Number(next);
                      let Pnew = pageNo; 

                      if (typeof count === 'number') {
                        const totalPages = Math.max(1, Math.ceil(count / Snew));
                        if (Pnew > totalPages) Pnew = totalPages;
                      }

                      setPaging({ pageNo: Pnew, pageSize: Snew });

                      onChangePageSize?.(Snew);
                      onChangePageIndex?.(Pnew);
                    }}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
